import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const baseURL = process.env.REACT_APP_API_BASE_URL;

export default function useSessionManager() {
  const navigate = useNavigate();
  const idleTimer = useRef<NodeJS.Timeout | null>(null);
  const refreshTimer = useRef<NodeJS.Timeout | null>(null);

  const logout = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  const refreshToken = async () => {
    const refreshToken = sessionStorage.getItem("refreshToken");
    if (!refreshToken) return logout();

    try {
      const res = await fetch(`${baseURL}/auth/refresh-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken }),
      });

      if (!res.ok) return logout();

      const data = await res.json();
      sessionStorage.setItem("authToken", data.accessToken);
      if (data.refreshToken)
        sessionStorage.setItem("refreshToken", data.refreshToken);
    } catch {
      logout();
    }
  };

  const resetIdleTimer = () => {
    if (idleTimer.current) clearTimeout(idleTimer.current);
    idleTimer.current = setTimeout(logout, 15 * 60 * 1000);

    // start refresh cycle only when active
    if (!refreshTimer.current) {
      refreshTimer.current = setInterval(refreshToken, 14 * 60 * 1000);
    }
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((e) => window.addEventListener(e, resetIdleTimer));
    resetIdleTimer();

    return () => {
      if (idleTimer.current) clearTimeout(idleTimer.current);
      if (refreshTimer.current) clearInterval(refreshTimer.current);
      events.forEach((e) => window.removeEventListener(e, resetIdleTimer));
    };
  }, []);
}
